import React from 'react';

export default function RSSIcon() {
  return (
    <svg width="56" height="56" fill="none" viewBox="0 0 56 56">
      <path
        fill="url(#paint0_linear_10353_4030)"
        fillRule="evenodd"
        d="M42 56H14A14 14 0 010 42V14A14 14 0 0114 0h28a14 14 0 0114 14v28a14 14 0 01-14 14z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M15.75 43.75a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.75 12.25a3.5 3.5 0 100 7 21.01 21.01 0 0121 21 3.5 3.5 0 107 0 28.014 28.014 0 00-28-28z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.75 24.5a3.5 3.5 0 100 7 8.754 8.754 0 018.75 8.75 3.5 3.5 0 107 0A15.757 15.757 0 0015.75 24.5z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4030"
          x1="12"
          x2="34.5"
          y1="0"
          y2="52.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9261" />
          <stop offset="1" stopColor="#FF5000" />
        </linearGradient>
      </defs>
    </svg>
  );
}
